import { CHECK_IN_GEOFENCE_RADIUS_METERS } from './publicMoorageConstants';

export const CHECK_IN_LOCATION_REQUIRED_ERROR =
  'Location access is required to check in to a public moorage.';
export const CHECK_IN_OUTSIDE_GEOFENCE_ERROR = 'You need to be near this moorage to check in.';
export const CHECK_IN_GEOFENCE_BYPASS_ENV = 'REACT_APP_BYPASS_CHECKIN_GEOFENCE';

let hasWarnedAboutGeofenceBypass = false;

const toRadians = degrees => (degrees * Math.PI) / 180;

const getListingCoordinates = listing => {
  const geolocation = listing?.attributes?.geolocation;
  const lat = geolocation?.lat;
  const lng = geolocation?.lng;
  return Number.isFinite(lat) && Number.isFinite(lng) ? { latitude: lat, longitude: lng } : null;
};

const isProductionEnvironment = () =>
  process.env.REACT_APP_ENV === 'production' || process.env.NODE_ENV === 'production';

export const isCheckInGeofenceBypassEnabled = () => {
  const enabled =
    process.env[CHECK_IN_GEOFENCE_BYPASS_ENV] === 'true' && !isProductionEnvironment();

  if (
    enabled &&
    process.env.REACT_APP_ENV === 'development' &&
    !hasWarnedAboutGeofenceBypass
  ) {
    hasWarnedAboutGeofenceBypass = true;
    // eslint-disable-next-line no-console
    console.warn('Public Moorage check-in geofence bypass is enabled for development.');
  }

  return enabled;
};

export const distanceInMeters = (from, to) => {
  const earthRadiusMeters = 6371000;
  const deltaLat = toRadians(to.latitude - from.latitude);
  const deltaLng = toRadians(to.longitude - from.longitude);
  const lat1 = toRadians(from.latitude);
  const lat2 = toRadians(to.latitude);
  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadiusMeters * c;
};

export const getBrowserCoordinates = () =>
  new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(new Error(CHECK_IN_LOCATION_REQUIRED_ERROR));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords || {};
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          reject(new Error(CHECK_IN_LOCATION_REQUIRED_ERROR));
          return;
        }
        resolve({ latitude, longitude });
      },
      () => reject(new Error(CHECK_IN_LOCATION_REQUIRED_ERROR)),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 }
    );
  });

export const validateCheckInGeofence = ({
  listing,
  userCoordinates,
  radiusMeters = CHECK_IN_GEOFENCE_RADIUS_METERS,
}) => {
  if (isCheckInGeofenceBypassEnabled()) {
    return { distance: null, radiusMeters, bypassed: true };
  }

  const listingCoordinates = getListingCoordinates(listing);
  if (!listingCoordinates || !userCoordinates) {
    throw new Error(CHECK_IN_LOCATION_REQUIRED_ERROR);
  }

  const distance = distanceInMeters(userCoordinates, listingCoordinates);
  if (distance > radiusMeters) {
    throw new Error(CHECK_IN_OUTSIDE_GEOFENCE_ERROR);
  }

  return { distance, radiusMeters };
};
